<script lang="ts">
  import Label from '$provider/constants/Label';
  import type { AlertOption } from '$provider/models/AlertOption';

  interface Props {
    data: string;
    options: AlertOption;
    onclick?: (e: MouseEvent) => void;
    children?: import('svelte').Snippet;
  }

  let { data, options, onclick, children }: Props = $props();

  let showReasons = $state(false);

  const onClickToggleReasons = () => {
    showReasons = !showReasons;
  };
</script>

<div class="simple-alert">
  {#if data}
    <div class="message">
      <div class="text" data-cy="alert-text">{@html data}</div>
      {#if options?.hasAction}
        <button type="button" class="action-button" data-cy="alert-detail" {onclick}>
          {options?.actionLabel || Label.Details}
        </button>
      {/if}
      {#if options?.hasReasons}
        <button type="button" class="toggle-button" onclick={onClickToggleReasons}>Why?</button>
      {/if}
    </div>
  {/if}
  {@render children?.()}
  {#if options?.hasReasons}
    <div class="reasons" class:show={showReasons}>
      {#each options?.reasons || [] as reason, index}
        <div class="reason" data-cy={`alert-message-${index}`}>{@html reason}</div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .simple-alert {
    display: inline-flex;
    align-items: center;
    flex-direction: column;
  }
  .message {
    text-align: center;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .message .action-button {
    margin-left: 4px;
    font-size: 14px;
    line-height: 22px;
    color: inherit;
    text-decoration: underline;
  }

  .message .toggle-button {
    margin-left: 4px;
    font-size: 14px;
    line-height: 22px;
    color: var(--red);
    text-decoration: underline;
  }

  .message .text :global(a) {
    font-weight: 600;
    text-decoration: underline;
    color: inherit;
  }
  .reasons {
    margin-top: 4px;
    display: none;
  }

  .reasons.show {
    display: block;
  }

  .reason:not(:last-child) {
    margin-bottom: 4px;
    line-height: 22px;
    font-size: 14px;
  }
</style>
